export default function hexToNormalizedRGB(hex: string) {
  if (!hex) return '1.0,1.0,1.0';
  if (!hex.includes('#')) return hex;

  const clean = hex.replace(/^#/, '');
  const isShort = clean.length === 3;

  const rHex = isShort ? clean[0] + clean[0] : clean.slice(0, 2);
  const gHex = isShort ? clean[1] + clean[1] : clean.slice(2, 4);
  const bHex = isShort ? clean[2] + clean[2] : clean.slice(4, 6);

  const r = parseInt(rHex, 16) / 255;
  const g = parseInt(gHex, 16) / 255;
  const b = parseInt(bHex, 16) / 255;

  const round = (v: number) => Number(v.toFixed(3));

  return `${round(r)},${round(g)},${round(b)}`;
}
